import {register} from '../vendor/theme-scripts/theme-sections';
import {Ticker} from '../features/ticker';
import {Slider} from '../features/slider';

const selectors = {
  bar: '[data-bar]',
  barSlide: '[data-slide]',
  frame: '[data-ticker-frame]',
  header: '[data-header-wrapper]',
  slider: '[data-slider]',
  slideValue: 'data-slide',
  tickerScale: '[data-ticker-scale]',
  tickerText: '[data-ticker-text]',
  dataTargetReferrer: 'data-target-refferer',
  slideValue: 'data-slide',
  dataSlideIndex: 'data-slide-index',
  firstSection: '#MainContent > *:first-child',
  topPosition: 'data-bar-top',
  highPosition: 'data-bar-high',
  lowPosition: 'data-bar-low',
};

const classes = {
  visible: 'is-visible',
};

const sections = {};
const barPositions = [selectors.topPosition, selectors.highPosition, selectors.lowPosition];
let arrayOfDuplicatedHolders;

class Bar {
  constructor(holder, isLast, isFirst) {
    this.barHolder = holder;
    this.isLastBar = isLast;
    this.isFirstBar = isFirst;
    this.locationPath = location.href;

    this.slides = this.barHolder.querySelectorAll(selectors.barSlide);
    this.slider = this.barHolder.querySelector(selectors.slider);
    this.header = document.querySelector(selectors.header);
    this.firstSection = document.querySelector(selectors.firstSection);

    if (this.isFirstBar) {
      // Array of bars holders
      arrayOfDuplicatedHolders = [selectors.topPosition, selectors.highPosition, selectors.lowPosition];
    }

    this.init();
  }

  init() {
    this.removeAnnouncement();
    this.removeLastHolder();
    this.moveBars();

    if (this.slider) {
      this.initSliders();
    }

    if (!this.slider) {
      this.initTickers(true);
    }
  }

  /**
   * Delete announcement which has a target referrer attribute and it is not contained in page URL
   */
  removeAnnouncement() {
    for (let index = 0; index < this.slides.length; index++) {
      const element = this.slides[index];

      if (!element.hasAttribute(selectors.dataTargetReferrer)) {
        continue;
      }

      if (this.locationPath.indexOf(element.getAttribute(selectors.dataTargetReferrer)) === -1 && !window.Shopify.designMode) {
        element.parentNode.removeChild(element);
      }
    }
  }

  /**
   * Move the bar to the current position
   */
  moveBars() {
    if (this.barHolder.hasAttribute(selectors.highPosition) && this.header) {
      if (this.header.parentNode.querySelector(selectors.bar)) {
        this.header.parentNode.removeChild(this.header.nextElementSibling);
      }

      this.header.insertAdjacentElement('afterend', this.barHolder);
    }

    if (this.barHolder.hasAttribute(selectors.lowPosition) && this.firstSection) {
      if (this.firstSection.parentNode.querySelector(selectors.bar)) {
        this.firstSection.parentNode.removeChild(this.firstSection.nextElementSibling);
      }

      this.firstSection.insertAdjacentElement('afterend', this.barHolder);
    }

    this.barHolder.classList.add(classes.visible);
  }

  /**
   * Init slider
   */
  initSliders() {
    this.slider = new Slider(this.barHolder);
    this.slider.flkty.reposition();

    this.barHolder.addEventListener('slider-is-loaded', () => {
      this.initTickers();
    });
  }

  /**
   * Init tickers in sliders
   */
  initTickers(stopClone = false) {
    const frames = this.barHolder.querySelectorAll(selectors.frame);

    frames.forEach((element) => {
      new Ticker(element, stopClone);
    });
  }

  /**
   * Remove bar child if it is only one and it is moved to another position
   */
  removeLastHolder() {
    barPositions.filter((attribute) => {
      if (this.barHolder.hasAttribute(attribute)) {
        const index = barPositions.indexOf(attribute);

        arrayOfDuplicatedHolders[index] = '';
        return attribute;
      }
    });

    if (this.isLastBar) {
      arrayOfDuplicatedHolders.forEach((element) => {
        if (element !== '') {
          const barHolder = document.querySelector(`[${element}]`);

          if (barHolder !== null) {
            barHolder.parentNode.removeChild(barHolder);
          }
        }
      });
    }
  }

  toggleTicker(e, isStoped) {
    const tickerScale = this.barHolder.querySelector(selectors.tickerScale);
    const element = this.barHolder.querySelector(`[${selectors.slideValue}="${e.detail.blockId}"]`);

    if (isStoped) {
      tickerScale.setAttribute('data-stop', '');
      tickerScale.querySelectorAll(selectors.tickerText).forEach((textHolder) => {
        textHolder.classList.remove('ticker--animated');
        textHolder.style.transform = `translate3d(${-(element.offsetLeft - element.clientWidth)}px, 0, 0)`;
      });
    }

    if (!isStoped) {
      tickerScale.querySelectorAll(selectors.tickerText).forEach((textHolder) => {
        textHolder.classList.add('ticker--animated');
        textHolder.removeAttribute('style');
      });
      tickerScale.removeAttribute('data-stop');
    }
  }

  onBlockSelect(e) {
    if (this.slider) {
      this.slider.onBlockSelect(e);
    } else {
      this.toggleTicker(e, true);
    }
  }

  onBlockDeselect(e) {
    if (this.slider) {
      this.slider.onBlockDeselect(e);
    } else {
      this.toggleTicker(e, false);
    }
  }
}

const bar = {
  onLoad() {
    sections[this.id] = [];
    const elements = this.container.querySelectorAll(selectors.bar);

    elements.forEach((el, i) => {
      sections[this.id].push(new Bar(el, i === elements.length - 1, i === 0));
    });
  },
  onBlockSelect(e) {
    sections[this.id].forEach((el) => {
      if (typeof el.onBlockSelect === 'function') {
        el.onBlockSelect(e);
      }
    });
  },
  onBlockDeselect(e) {
    sections[this.id].forEach((el) => {
      if (typeof el.onBlockSelect === 'function') {
        el.onBlockDeselect(e);
      }
    });
  },
};

register('announcement', [bar]);
